import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { DetailsRows } from 'UI';
import { formattedCurrency, Card } from 'vopay';

type FileUploadHeaderProps = {
  product: string;
  service: string;
  fileName: string;
  numberOfTransactions: number;
  amount: number;
  currency: string;
};

type FC = FunctionComponent<FileUploadHeaderProps>;

const FileUploadHeader: FC = (props: FileUploadHeaderProps) => {
  const { product, service, fileName, numberOfTransactions, amount, currency } = props;
  const { t } = useTranslation('translations', { keyPrefix: 'FileUpload.Review.Header' });

  const details = [
    {
      label: t('transferType'),
      value: service,
    },
    {
      label: t('paymentRail'),
      value: product,
    },
    {
      label: t('currency'),
      value: currency,
    },
    {
      label: t('fileName'),
      value: fileName,
    },
    {
      label: t('numberOfTransactions'),
      value: numberOfTransactions,
    },
    {
      label: t('totalAmount'),
      value: `$${formattedCurrency(amount.toString() || '')}`,
    },
  ];

  return (
    <Card>
      <DetailsRows details={details} />
    </Card>
  );
};

export default FileUploadHeader;
